import React from 'react';
import { styled } from '@linaria/react';

import Demo, { DemoSliderControl } from '@/components/Demo';
import { normalize, roundTo } from '@/utils';

const STRETCH_AMOUNT = 3;

function StretchyArrowDemo() {
  return (
    <Demo
      outputWrapper={OutputWrapper}
      initialValues={{
        stretchAmount: 0,
      }}
      controlPosition="bottom"
      customGrid={{
        gridTemplateColumns: 'min(400px, 100%)',
        justifyContent: 'center',
      }}
      controls={[
        <DemoSliderControl
          key="stretchAmount"
          id="stretchAmount"
          label="Stretch Amount"
          min={0}
          max={100}
          step={1}
          previewRenderer={(value) => {
            return `${Math.round(Number(value))}%`;
          }}
        />,
      ]}
    >
      {({ stretchAmount }) => {
        const lineX2 = roundTo(
          normalize(stretchAmount, 0, 100, 18, 18 + STRETCH_AMOUNT),
          2
        );
        const points = getPoints(stretchAmount);

        return (
          <Svg viewBox="0 0 24 24" fill="none">
            <line x1="5" y1="12" x2={lineX2} y2="12" />
            <polyline points={points} />
          </Svg>
        );
      }}
    </Demo>
  );
}

function getPoints(stretchAmount: number) {
  const p1x = roundTo(
    normalize(stretchAmount, 0, 100, 12, 12 + STRETCH_AMOUNT),
    2
  );
  const p1y = roundTo(normalize(stretchAmount, 0, 100, 5, 7), 2);
  const p2x = roundTo(
    normalize(stretchAmount, 0, 100, 19, 19 + STRETCH_AMOUNT),
    2
  );
  const p2y = 12;
  const p3x = p1x;
  const p3y = roundTo(normalize(stretchAmount, 0, 100, 19, 17), 2);

  return `${p1x},${p1y} ${p2x},${p2y} ${p3x},${p3y}`;
}

const OutputWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
  padding-bottom: 32px;
`;

const Svg = styled.svg`
  transition: opacity 250ms;
  width: 128px;
  height: 128px;
  overflow: visible;
  fill: none;
  stroke: white;
  stroke-width: 2px;
  stroke-linecap: round;
  stroke-linejoin: round;
  outline: 1px solid var(--color-gray-300);
  outline-offset: 12px;
`;

export default StretchyArrowDemo;
